module.exports = __webpack_public_path__ + "videos/careers_3x4.94e435c.mp4";